<template>
    <div class="contacto">
            <div class="main col-lg-12" >
                <h5 class="col-lg-12">Editar Aviso de privacidad</h5>
                
                <div class="container text-right" id="top">
                  <b-button pill v-b-modal.politics-modal class="btnAdd"><i class="fa fa-plus mr-3"></i> Crear Politica</b-button>
                    <div class="politicas text-left">
                      
                    <div v-for="politica in datapoliticas" :value="politica.value" :key="politica.value">
                        <span class="">{{politica.orden}} - {{politica.titulo}}</span>
                        <div class="float-right">
                        <b-link :title="'Editar - '+ politica.titulo" class="mr-5 btnEdit" @click="editPolitica(politica)"></b-link>
                        <b-link :title="'Eliminar - '+ politica.titulo" class="btnDelete" @click="deletePolitica(politica)"></b-link>
                        </div>
                        <p>{{politica.descripcion}}</p>
                        <br>
                    </div>
                    <b-link :to="'/aviso'" class="float-right link">Ver <b-icon icon="chevron-right" class="ml-2 chevron"></b-icon></b-link>
                    </div>
                    
                </div>
                

  

    <b-modal ref="politics-modal" :modal-class="politics-modal" id="politics-modal" no-close-on-backdrop scrollable hide-header>
     <div class="d-block text-center">
        <div class="col-lg-12">
                  <h2>{{form_title}}</h2>
                   <ValidationObserver ref="form" >
                        <b-form id="form" class="form-container">
                        <div class="form-group">
                            <label for="orden">Orden</label>
                            <ValidationProvider rules="required"  v-slot="{ errors }">
                                <b-form-input v-model="orden" min="1" step="0.1" name="orden" type="number" placeholder="Orden"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label for="Titulo">Titulo</label>
                            <ValidationProvider rules="required|max:200"  v-slot="{ errors }">
                                <b-form-input v-model="titulo" name="Titulo" type="text" placeholder="Titulo"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label for="descripcion">Descripción</label>
                            <ValidationProvider v-slot="{ errors }">
                                <b-form-textarea v-model="descripcion" rows="6" name="descripcion"  placeholder=""/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </b-form>
                    </ValidationObserver>
        </div>
      </div>
    <template #modal-footer="{}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button v-show="!loading && !editing" type="submit" pill class="btnSend" @click="onSubmit()">Guardar</b-button>
      <b-link v-show="!loading && !editing" class="btnCancel" @click="$refs['politics-modal'].hide();"></b-link>
      <b-button v-show="!loading && editing" type="submit" pill class="btnSend" @click="onSubmit()">Guardar Cambios</b-button>
      <b-link v-show="!loading && editing" class="btnCancel" @click="reset();"></b-link>
      <b-button v-show="loading" class="btnSend" pill disabled="disabled"><b-spinner small class="mr-2"></b-spinner>ENVIANDO</b-button>
    </template>
  </b-modal>
                <!--main-center"-->
            </div><!--main-->
    </div>
</template>

<script>

import env from '@/plugins/enviroment';
import politicasApi from "../api/politicas";
import {ValidationProvider,ValidationObserver} from 'vee-validate';
import {mapState,mapActions} from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";


export default {
  name: 'politics-manager',
  components: {
      ValidationProvider,
      ValidationObserver
  },
  data() {
      return {
        form_title:"Nueva Politica",
        id:null,
        orden:null,
        titulo:"",
        descripcion:"",
        datapoliticas: [],
        show            : true,
        loading:false,
        editing:false,
      }
    },
    methods: {
      editPolitica(data){

        this.editing = true;
        this.form_title = "Editar Politica";
        this.id = data.id; 
        this.orden = data.orden; 
        this.titulo = data.titulo;
        this.descripcion = data.descripcion;
        
        this.$refs['politics-modal'].show();
      },
      onSubmit(){
  
        if(this.editing){
            this.updatePolitic();
          }else{
            this.postPolitic();
          }
      },
      getPoliticas(){
      politicasApi
      .getPoliticas()
      .then(response => {
        this.datapoliticas = response.data.data;
      }).catch(err => {
        console.log("Ocurrio un error al cargar las politicas.");
      });
        
    },
    async postPolitic(){
      var isValid = await this.$refs.form.validate();
      if (!isValid) {
        Notify.WarningToast("Verifique que los campos obligatorios estén completos.");
      }else{
        this.loading = true;

        let data = {orden:this.orden,titulo:this.titulo,descripcion:this.descripcion};
        
       await politicasApi
          .createPolitica(data)
          .then(response => {
            Notify.Success("¡Excelente!", "La Política de Privacidad se agrego con éxito.");
            this.reset();
            this.$refs['politics-modal'].hide();
            this.getPoliticas();
          }).catch(err => {
            Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible agregar la política de privacidad, inténtalo nuevamente.");
          });
      }
      this.loading = false;
    },
    async updatePolitic(){
     var isValid = await this.$refs.form.validate();
      if (!isValid) {
        Notify.WarningToast("Verifique que los campos obligatorios estén completos.");
      }else{
        this.loading = true;

        let data = {id:this.id,orden:this.orden,titulo:this.titulo,descripcion:this.descripcion};
        
       await politicasApi
          .updatePolitica(data)
          .then(response => {
            Notify.Success("¡Excelente!", "La Política de Privacidad se actualizó con éxito.");
            this.reset();
            this.$refs['politics-modal'].hide();
            this.getPoliticas();
          }).catch(err => {
            Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible actualizar la política de privacidad, inténtalo nuevamente.");
          });
      }
      this.loading = false;
    },
    deletePolitica(data){
      let self = this;
      Notify.Confirm("Espere", "¿Está seguro de eliminar la Política de Privacidad: "+data.titulo+"?, Se eliminará permanentemente.", "Aceptar", "Cancelar",
      function OnSucces(){
        politicasApi
        .deletePolitica(data.id)
        .then(response => {
            Notify.Success("¡Listo!","La Política de Privacidad: "+data.titulo+" ha sido eliminada correctamente.",null,
            function ok(){
              self.getPoliticas();
            });
          }).catch(err => {
            Notify.ErrorToast("Lo sentimos: Ocurrió un error - La Política de Privacidad no se eliminó.");
          });
        });
    },
    reset() {
      this.$nextTick(() => {
          this.$refs.form.reset();
          this.form_title = "Nueva Politica";
          this.editing = false;
         
          this.id = null; 
          this.orden = null; 
          this.titulo = "";
          this.descripcion = "";

          this.$refs['politics-modal'].hide();
          window.location = "#top";
        });
      },
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    init(){
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera;
      this.getPoliticas();
    }
    },
    created () {
      this.init();
    },
}
</script>

<style scoped>

.link{
font-family: Muli;
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 135.94%;
color: #2DB9D1;
}
 .btnDelete{
    content: url("/static/images/icons/delete.svg");
  }
  
  .btnEdit{
    content: url("/static/images/icons/edit.svg");
  }



.politicas{
  margin-top:100px;
  margin-bottom:100px;
  text-align: left;
}

.politicas p{
  font-family: Muli;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 25px;
letter-spacing: 0.2px;
color: #1E2144;
padding-top:20px;
}

.politicas span{
font-family: Muli;
font-style: normal;
font-weight: bold;
font-size: 24px;
line-height: 25px;
letter-spacing: 0.2px;
color: #1E2144;

}

h2{
  font-family: Muli;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 50px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2px;
  color: #1E2245;
}

.postImage img{
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ced3da;
}

.google-terms{
     margin:15px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #828282;
}

.error{
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    color:red;
}
    h5 {
        font-family: Muli;
        font-style: normal;
        font-size: 38px;
        line-height: 18px;

        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2144;

        margin: 100px 0px;
    }
    .btnAdd {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background:#1E2245;
    border-color:#1E2245!important;
    border-radius: 18px;
    color: #FFFFFF;
    margin-top: 30px;
    padding: 13px 27px;
  }
  .btnAdd > i{
    color:#2DB9D1;
  }

  .btnAdd:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .btnSend {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    padding: 13px 40px;
  }

  .btnCancel {
    content: url("/static/images/icons/cancel.svg");
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    border-radius: 150px;
    background-color: #F2F2F2;
    border-color: #F2F2F2;
    display: block;
    padding:16px;
    transition:0.2s;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
  .btnCancel:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .cliker-text{
      color:#2DB9D1;
  }

    .main{
        padding: 40px 0;
        background:  url("/static/images/bg_azul_categoria.svg") repeat-x;
    }
    .main input {
        font-size: 11px;
        padding-top: 3px;
        border: 1px solid #E0E0E0;
        border-radius: 5px;
    }
    .main-center{
        margin-top: 30px;
        margin-bottom: 120px !important;
        margin: 0 auto;
        max-width: 600px;
        padding: 10px 40px;
        background:#FFFFFF;
        text-shadow: none;
        -webkit-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        -moz-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        border-radius: 25px;
    }

   .form-container {
        padding: 50px 0px;
    }
  .form-group{
    margin-bottom: 30px;
  }
    .form-group > label {
        font-family: Muli;
        font-style: normal;
        font-size: 16px;
        line-height: 16px;
        float:left;
        margin-left:20px;
        letter-spacing: 2px;
        color: #1E2144;
    }
    .placeholder {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;

        color: #BDBDBD;
    }

    .help {
        margin-top: 50px;
    }

    span.input-group-addon i {
        color: #009edf;
        font-size: 17px;
    }

     @media(max-width: 768px){
          h5 {
        font-size: 24px;
        line-height: 35px;
        margin: 0px 0px;
    }

        .main-center{
      
        background: none;
        -webkit-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        -moz-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        }

.btnSend {
    width: 100%;
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
        
     }
</style>